var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramStageTabT(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 60,
    viewBox: "0 0 130 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_14368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79 28H75.5009V3.49906H54.4991V28H51V0H79V28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0019 27.9996H68.5028V11.0235H61.4972V27.9996H57.9981V7.52441H72.0019V27.9996Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_524_14368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3217 37.3789H16.7244V58.6158H20.3217V37.3789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1256 37.3789H26.5284V58.6158H30.1256V37.3789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1036 45.6131L17.944 49.0576L19.1057 52.4406L29.2652 48.996L28.1036 45.6131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6361 37.4072H0V40.9817H12.6361V37.4072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11954 39.1943H4.52228V58.5929H8.11954V39.1943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1108 60L32.6152 47.2681L40.5291 36L43.4755 38.0426L37.0404 47.2057L45 57.8723L42.1108 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5554 45.4521H34.8306V49.0266H43.5554V45.4521Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_524_14368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.336 59.5571L99.0794 49.2252L99.0168 47.0805L106.556 36.4365L109.481 38.5018L102.715 48.045L108.565 55.3642L112.138 49.6904L108.514 49.9798L108.229 46.4167L115.416 45.8493L117.072 48.5784L110.255 59.3982L107.336 59.5571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1987 58.5754L89.7873 43.4605L84.6718 58.547L81.2804 57.4066L88.0404 37.452L89.5369 37.435L91.4261 37.418L98.573 57.3726L95.1987 58.5754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4178 52.3983L89.9312 49.9189L87.4446 52.3983L89.9312 54.8777L92.4178 52.3983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5052 59.4609L54.3031 56.6467L59.3674 52.7034L53 44.9644L61.2679 36.5332L63.8285 39.0353L57.8025 45.1743L64.4601 53.2708L56.5052 59.4609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9944 37.4072H67.4019V40.9817H79.9944V37.4072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4934 39.1943H71.9086V58.5929H75.4934V39.1943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.121 60L117.658 47.2681L125.545 36L128.481 38.0426L122.074 47.2057L130 57.8723L127.121 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.56 45.4521H119.866V49.0266H128.56V45.4521Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_14368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(51)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_524_14368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 24,
    fill: "white",
    transform: "translate(0 36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_524_14368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 24,
    fill: "white",
    transform: "translate(53 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramStageTabT);
export default __webpack_public_path__ + "static/media/programStageTabT.71e66303a8dfa2a0913a98b3df3ff265.svg";
export { ForwardRef as ReactComponent };